import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {CategoryGroupDetail} from "./category-group-detail";

const CategoryGroupDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/categorygroups');
    }

    return (
        <CategoryGroupDetail id={id} onClose={onClose}/>
    )

});

export default CategoryGroupDetailPage;